export default "__VITE_ASSET__qnkY9au9__"